export default __webpack_public_path__ + "static/media/vn.5d0e6fe0.svg";